import * as React from "react";
import styled, { css } from "../styled";
import { NavLink, NavLinkProps } from "react-router-dom";
import withMargin, { WithMarginProp } from "../styled/withMargin";
import { deprecatedTrack } from "../analytics";

// Filters out our custom props from NavLinkProps
// This is required for 3rd party components such as NavLink
const StyledNavLink = styled(
  ({ isDisabled, ...otherProps }: NavLinkProps & CommonLinkProps) => (
    <NavLink {...otherProps} />
  )
)`
  ${({ theme, isDisabled, size, color, weight, width }) => css`
    width: ${width};
    color: ${theme.color.blue70};
    font-weight: ${theme.typography.weight.bold};
    text-decoration: none;
    cursor: pointer;
    transition: color 0.2s;
    font-weight: ${
      weight ? theme.typography.weight[weight] : theme.typography.weight.normal
    };

    ${size &&
      css`
        font-size: ${size
          ? theme.typography.size[size]
          : theme.typography.size.m};

        line-height: ${size
          ? theme.typography.lineHeight[size]
          : theme.typography.lineHeight.m};
      `};

    &:hover,
    &:focus {
      color: ${theme.color.blue70};
    }

    ${color === "red" &&
      css`
        color: ${theme.color.red70};
      `}

    ${color === "gray" &&
      css`
        color: ${theme.color.gray70};

        &:hover {
          color: ${theme.color.gray90};
        }
      `}

    ${isDisabled &&
      css`
        color: ${theme.color.gray90};
        pointer-events: none;
      `}
  `}
  ${withMargin}
`;

type CommonLinkProps = Pick<
  LinkProps,
  "isDisabled" | "size" | "weight" | "width"
>;

type LinkProps = WithMarginProp &
  NavLinkProps & {
    onClick?: (event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => void;
    isDisabled?: boolean;
    children: React.ReactNode;
    trackEventName?: string;
    width?: string;
    size?: "xs" | "s" | "m" | "l";
    weight?: "normal" | "bold";
    color?: "red" | "gray";
  };

const InternalLink = ({
  children,
  isDisabled,
  to,
  size,
  margin,
  color,
  width = "100%",
  weight,
  onClick,
  trackEventName
}: LinkProps) => {
  return (
    <StyledNavLink
      width={width}
      color={color}
      size={size}
      margin={margin}
      to={to}
      exact={true}
      isDisabled={isDisabled}
      weight={weight}
      onClick={(event: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
        if (trackEventName) {
          deprecatedTrack(trackEventName);
        }

        if (onClick) {
          onClick(event);
        }
      }}
    >
      {children}
    </StyledNavLink>
  );
};

export default InternalLink;
